import { HeartHandshake, Building2, ShieldCheck, Clock } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const POINTS = [
  { icon: HeartHandshake, title: "NGO & Non-Profit Rates", desc: "Purpose-built agreements and priority scheduling for mission-driven organizations." },
  { icon: Building2, title: "Provider Coordination", desc: "We sync directly with care coordinators, clinics, and case managers for seamless handoffs." },
  { icon: ShieldCheck, title: "Fully Compliant", desc: "Licensed, insured, and trained for sensitive elderly, recovery, and mental-health transport." },
  { icon: Clock, title: "On-Time, Every Time", desc: "Dispatch discipline and live tracking so your people are never left waiting." },
];

export default function Partners({ onQuote }) {
  return (
    <section id="partners" className="relative py-28 lg:py-40 bg-ink-3" data-testid="partners">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>Partnerships</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif font-light text-cream text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
              Built to work with <span className="italic text-gold">NGOs & local providers.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-cream/60 font-light text-lg leading-relaxed">
              Whether you coordinate care for the elderly, run a recovery program, or serve your
              community through a non-profit — Peace Trucking becomes your dedicated transport arm.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-16">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <div className="h-full bg-ink/60 backdrop-blur border border-gold/10 p-8 hover:border-gold/40 transition-colors duration-500 group">
                <p.icon size={30} className="text-gold" strokeWidth={1.2} />
                <h3 className="mt-6 font-serif text-2xl text-cream font-light">{p.title}</h3>
                <p className="mt-3 text-cream/55 text-sm font-light leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-6 border border-gold/20 bg-ink/50 p-8 lg:p-12">
            <div className="font-serif text-2xl lg:text-3xl text-cream font-light text-center sm:text-left">
              Let's build a partnership that moves your mission forward.
            </div>
            <button
              onClick={onQuote}
              data-testid="partners-cta"
              className="btn-gold border border-gold text-gold px-8 py-4 tracking-widest text-sm whitespace-nowrap"
            >
              START A CONVERSATION
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
